module.exports = __webpack_public_path__ + "img/home.3f30f375.svg";